import BlockQuoteToolbarView from "./BlockQuoteToolbarView.vue";
import {Blockquote as BlockquoteExtension} from "@tiptap/extension-blockquote";

export default class BlockQuote {

    constructor() {
        this.toolbarView = BlockQuoteToolbarView;
    }

    static create() {
        return new BlockQuote();
    }

    getExtensions() {
        return [BlockquoteExtension];
    }
}